/* eslint-disable react/prop-types */

import React from 'react';

function TabNavigation({
 activeTab, onTabChange, isLoading, tabs,
}) {
  // Display friendly tab names based on the tab ID
  const getTabDisplayName = (tab) => tab.charAt(0).toUpperCase() + tab.slice(1);

  // Get icon based on tab type
  const getTabIcon = (tab) => {
    switch (tab) {
      case 'following':
        return <i className="fa-solid fa-bell me-2" />;
      case 'mute':
        return <i className="fa-solid fa-bell-slash me-2" />;
      case 'blocked':
        return <i className="fa-solid fa-ban me-2" />;
      default:
        return null;
    }
  };

  return (
    <ul className="nav nav-tabs">
      {tabs.map((tab) => (
        <li className="nav-item" key={tab}>
          <button
            className={`nav-link ${activeTab === tab ? 'active' : ''}`}
            onClick={() => !isLoading && onTabChange(tab)}
            type="button"
            disabled={isLoading}
          >
            {getTabIcon(tab)}
            {getTabDisplayName(tab)}
          </button>
        </li>
      ))}
    </ul>
  );
}

export default TabNavigation;
